var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPrimaryBlock = function SvgPrimaryBlock(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 24,
    viewBox: "0 0 56 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 2.5H2C1.17157 2.5 0.5 3.17157 0.5 4V20C0.5 20.8284 1.17157 21.5 2 21.5H54C54.8284 21.5 55.5 20.8284 55.5 20V4C55.5 3.17157 54.8284 2.5 54 2.5Z",
    stroke: "#DBE5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6H5C4.44772 6 4 6.44772 4 7V17C4 17.5523 4.44772 18 5 18H11C11.5523 18 12 17.5523 12 17V7C12 6.44772 11.5523 6 11 6Z",
    fill: "#DBE5E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 6H15C14.4477 6 14 6.44772 14 7V17C14 17.5523 14.4477 18 15 18H21C21.5523 18 22 17.5523 22 17V7C22 6.44772 21.5523 6 21 6Z",
    fill: "#DBE5E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 6H25C24.4477 6 24 6.44772 24 7V17C24 17.5523 24.4477 18 25 18H31C31.5523 18 32 17.5523 32 17V7C32 6.44772 31.5523 6 31 6Z",
    fill: "#DBE5E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41 6H35C34.4477 6 34 6.44772 34 7V17C34 17.5523 34.4477 18 35 18H41C41.5523 18 42 17.5523 42 17V7C42 6.44772 41.5523 6 41 6Z",
    fill: "#DBE5E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51 6H45C44.4477 6 44 6.44772 44 7V17C44 17.5523 44.4477 18 45 18H51C51.5523 18 52 17.5523 52 17V7C52 6.44772 51.5523 6 51 6Z",
    fill: "#DBE5E5"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrimaryBlock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/primary_block.330cb678.svg";
export { ForwardRef as ReactComponent };